"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = _interopRequireDefault(require("./constants"));
var browserFontSize = 16;
var coef = 1.6;
var theme = (0, _styles.createTheme)({
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          aspectRatio: '1 / 1'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: function root(_ref) {
          var ownerState = _ref.ownerState;
          return {
            padding: '6px 16px 7px 16px',
            borderRadius: 2,
            height: 32,
            gap: 8,
            textTransform: 'none',
            fontWeight: 'bold',
            lineHeight: 1,
            '&.Mui-disabled': {
              opacity: 0.4,
              color: theme.palette[ownerState.color].main
            },
            '&.MuiButton-endIcon': {
              fontSize: 14,
              ml: 0
            }
          };
        }
      },
      variants: [{
        props: {
          variant: 'input'
        },
        style: function style(_ref2) {
          var ownerState = _ref2.ownerState;
          return {
            borderColor: theme.palette[ownerState.color].main,
            borderRadius: 4,
            color: theme.palette[ownerState.color].main,
            borderWidth: 1,
            borderStyle: 'solid',
            height: 32
          };
        }
      }, {
        props: {
          variant: 'input',
          color: 'text'
        },
        style: function style(_ref3) {
          var t = _ref3.theme;
          return {
            borderColor: t.palette.primary.lightest
          };
        }
      }, {
        props: {
          variant: 'contained'
        },
        style: function style(_ref4) {
          var ownerState = _ref4.ownerState;
          return {
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none'
            },
            '&.Mui-disabled': {
              background: theme.palette[ownerState.color].main,
              color: _constants.default.white
            }
          };
        }
      }, {
        props: {
          variant: 'outlined'
        },
        style: function style(_ref5) {
          var ownerState = _ref5.ownerState;
          return {
            '&:active': {
              background: theme.palette[ownerState.color].light
            },
            '&.Mui-disabled': {
              background: _constants.default.white,
              color: theme.palette[ownerState.color].main,
              borderColor: theme.palette[ownerState.color].main,
              opacity: 0.4
            }
          };
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'secondary'
        },
        style: function style(_ref6) {
          var t = _ref6.theme;
          return {
            color: t.palette.text.main,
            borderColor: t.palette.silverSand.main,
            '&:active': {
              background: _constants.default.white
            },
            '&:hover': {
              background: t.palette.silverSand.light,
              color: t.palette.text.main,
              borderColor: t.palette.silverSand.main
            },
            '&:disabled': {
              color: t.palette.text.main,
              borderColor: t.palette.silverSand.main
            }
          };
        }
      }]
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: _constants.default.quartz,
          fontSize: 14,
          fontFamily: 'Open Sans',
          '&:hover': {
            background: _constants.default.aliceBlue
          }
        }
      }
    },
    MuiModal: {
      styleOverrides: {
        root: {
          '& .MuiMenu-paper': {
            overflow: 'visible'
          }
        }
      }
    }
  },
  palette: {
    primary: {
      main: _constants.default.vibrentBlue,
      dark: _constants.default.primaryHover,
      light: _constants.default.aliceBlue,
      lightest: _constants.default.columbiaBlue
    },
    secondary: {
      main: _constants.default.secondary,
      dark: _constants.default.secondaryHover
    },
    error: {
      main: _constants.default.error,
      dark: _constants.default.errorHover
    },
    text: {
      main: _constants.default.quartz,
      light: _constants.default.chalice
    },
    silverSand: {
      main: _constants.default.silverSand,
      light: _constants.default.antiFlashWhite
    }
  },
  typography: {
    fontSize: 14,
    pxToRem: function pxToRem(size) {
      return "".concat(size / browserFontSize * coef, "rem");
    },
    fontFamily: 'Open Sans'
  }
});
var Theme = function Theme(props) {
  var children = props.children;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, children);
};
Theme.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Theme;
exports.default = _default;